/**
 * PUBLISHER CONFIGURATION
 * Configuración de Marca Blanca (White Labeling) para Editoriales.
 * Permite cambiar los colores, logos y nombre de la aplicación sin modificar el núcleo.
 */

window.PUBLISHER_THEMES = {
    // ---------------------------------------------------------
    // TEMA POR DEFECTO (El original de Detectimáticas)
    // ---------------------------------------------------------
    default: {
        id: 'default',
        branding: {
            appName: "DETECTIMÁTICAS DE 1º",
            appShortName: "DETECTIVES",
            companyName: "SSWORK",
            showBrandFooter: true,
            logoUrl: null, // Si es null, usa el texto. Si es una URL, reemplaza el título con la imagen.
            detectiveAvatarUrl: "assets/images/detectives/default-mentor.png" // ED-03: Sustituible
        },
        telemetry: {
            endpointUrl: "https://api.editorial.com/metrics" // ED-07: URL mock para datos
        },
        colors: {
            primary: "#6366F1",
            primaryDark: "#4338CA",
            primaryLight: "#818CF8",
            secondary: "#EC4899",
            secondaryDark: "#BE185D",
            secondaryLight: "#F472B6",
            accent: "#F59E0B",
            accentDark: "#B45309",
            bgDarkest: "#1d4ed8", // blue-700
            bgMid: "#3b82f6",     // blue-500
            bgLight: "#0ea5e9",   // sky-500
            bgLighter: "#8b5cf6"  // violet-500
        }
    },

    // ---------------------------------------------------------
    // TEMA EDITORIAL A (Ejemplo: "NovaEduca" - Naranja y Azul)
    // ---------------------------------------------------------
    novaEduca: {
        id: 'novaEduca',
        branding: {
            appName: "NOVA MATEMÁTICAS 1º",
            appShortName: "NOVA MATES",
            companyName: "NOVA EDUCA",
            showBrandFooter: true,
            logoUrl: null
        },
        colors: {
            primary: "#f97316", // Naranja brillante
            primaryDark: "#c2410c",
            primaryLight: "#fdba74",
            secondary: "#0284c7", // Azul oceano
            secondaryDark: "#0369a1",
            secondaryLight: "#7dd3fc",
            accent: "#10b981", // Verde esmeralda
            accentDark: "#047857",
            bgDarkest: "#082f49", // Fondo azul oscuro
            bgMid: "#0c4a6e",
            bgLight: "#0f172a",
            bgLighter: "#1e293b"
        }
    },

    // ---------------------------------------------------------
    // TEMA EDITORIAL B (Ejemplo: "EduNature" - Verde y Tierra)
    // ---------------------------------------------------------
    eduNature: {
        id: 'eduNature',
        branding: {
            appName: "EXPLORADORES MATEMÁTICOS",
            appShortName: "EXPLORADORES",
            companyName: "EDU NATURE",
            showBrandFooter: true,
            logoUrl: null
        },
        colors: {
            primary: "#22c55e", // Verde vibrante
            primaryDark: "#15803d",
            primaryLight: "#86efac",
            secondary: "#eab308", // Amarillo tierra
            secondaryDark: "#a16207",
            secondaryLight: "#fde047",
            accent: "#ef4444", // Rojo baya
            accentDark: "#b91c1c",
            bgDarkest: "#14532d", // Fondo bosque oscuro
            bgMid: "#166534",
            bgLight: "#422006", // Marrón oscuro
            bgLighter: "#78350f" // Marrón tierra
        }
    }
};

// Configuración activa por defecto
window.PUBLISHER_CONFIG = window.PUBLISHER_THEMES['default'];
